import React from "react";
//#region types
import { IconTitleProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import Tags from "../tags";
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const IconTitle: React.FC<IconTitleProps> = (props) => {
  return (
    <Grid container spacing={2} className={cssExports.iconTitleContainer}>
      <Grid item className={cssExports.dashboardHeaderIcon}>
        {props.icon}
      </Grid>
      <Grid item xs container direction={"column"}>
        <Grid item className={cssExports.dashboardHeaderText}>
          {LocalizationHelperInstance.getFormattedMessage(props.title)}
        </Grid>
        <Grid item container direction="row" spacing={1}>
          {props.subtitle && (
            <Grid item>
              <Tags
                tags={[LocalizationHelperInstance.getFormattedMessage(props.subtitle ?? "")]}
                className={props.defaultTagColor ?? cssExports.blueTag}
                surface={props.defaultTagSurface}
              />
            </Grid>
          )}
          {props.extraTags &&
            props.extraTags.map((tag, index) => (
              <Grid item key={`extra-tag-${index}`}>
                <Tags
                  {...tag}
                  className={tag.className ?? props.defaultTagColor ?? cssExports.blueTag}
                  surface={tag.surface ?? props.defaultTagSurface}
                />
              </Grid>
            ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default IconTitle;
